import {
    Skeleton,
    TableCell,
    TableRow,
  
  } from "@mui/material";
  import React from "react";
export function DashboardTableLoader({ rows }) {
    return [...Array(rows)].map((elementInArray, index) => (
        <div>
      <TableRow hover tabIndex={-1} key={index}>
        <TableCell align="left">
          <Skeleton variant="rectangular" width={800} sx={{ my: 1.5 }} />
        </TableCell>
        </TableRow>
           <TableRow hover tabIndex={-1} key={index}>
        <TableCell align="left">
          <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
        </TableCell>
        </TableRow>
           <TableRow hover tabIndex={-1} key={index}>
        <TableCell align="left">
          <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
        </TableCell>
        </TableRow>
           <TableRow hover tabIndex={-1} key={index}>
        <TableCell align="left">
          <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
        </TableCell>
        </TableRow>
           <TableRow hover tabIndex={-1} key={index}>
        <TableCell align="left">
          <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
        </TableCell>
        </TableRow>
           <TableRow hover tabIndex={-1} key={index}>
        <TableCell align="left">
          <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
        </TableCell>
        </TableRow>
           <TableRow hover tabIndex={-1} key={index}>
        <TableCell align="left">
          <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
        </TableCell>
      </TableRow>
      </div>
    ));
  }

  export function TermsTableLoader({ rows,width }) {
    return [...Array(rows)].map((elementInArray, index) => (
        <div>
      <TableRow hover tabIndex={-1} key={index} >
        <TableCell align="left" >
          <Skeleton variant="rectangular" width={900} sx={{ my: 1.5 }} />
        </TableCell>
        </TableRow>
           <TableRow hover tabIndex={-1} key={index}>
        <TableCell align="left">
          <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
        </TableCell>
        </TableRow>
           <TableRow hover tabIndex={-1} key={index}>
        <TableCell align="left">
          <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
        </TableCell>
        </TableRow>
           <TableRow hover tabIndex={-1} key={index}>
        <TableCell align="left">
          <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
        </TableCell>
        </TableRow>
           <TableRow hover tabIndex={-1} key={index}>
        <TableCell align="left">
          <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
        </TableCell>
        </TableRow>
           <TableRow hover tabIndex={-1} key={index}>
        <TableCell align="left">
          <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
        </TableCell>
        </TableRow>
           <TableRow hover tabIndex={-1} key={index}>
        <TableCell align="left">
          <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
        </TableCell>
      </TableRow>
      </div>
    ));
  }

  export function TenantProfileTableLoader({ rows,width }) {
    return [...Array(rows)].map((elementInArray, index) => (
        <div>
      <TableRow hover tabIndex={-1} key={index} >
      <div style={{ width: '100%', overflow: 'hidden' }}>
        <TableCell align="left" >
          <Skeleton variant="rectangular" width={733}  sx={{ my: 1.5,maxWidth:"100%" }} />
        </TableCell>
        </div>
        </TableRow>
           <TableRow hover tabIndex={-1} key={index}>
        <TableCell align="left">
          <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
        </TableCell>
        </TableRow>
           <TableRow hover tabIndex={-1} key={index}>
        <TableCell align="left">
          <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
        </TableCell>
        </TableRow>
      
      
      </div>
    ));
  }

  export function TenantProfileTableLoader1({ rows,width }) {
    return [...Array(rows)].map((elementInArray, index) => (
        <div>
      <TableRow hover tabIndex={-1} key={index} >
      <div style={{ width: '100%', overflow: 'hidden' }}>
        <TableCell align="left" >
          <Skeleton variant="rectangular" width={1000}  sx={{ my: 1.5,maxWidth:"100%" }} />
        </TableCell>
        </div>
        </TableRow>
           <TableRow hover tabIndex={-1} key={index}>
        <TableCell align="left">
          <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
        </TableCell>
        </TableRow>
           <TableRow hover tabIndex={-1} key={index}>
        <TableCell align="left">
          <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
        </TableCell>
        </TableRow>
      
      
      </div>
    ));
  }

  export function TenantTableLoader({ rows }) {
    return [...Array(rows)].map((elementInArray, index) => (
      <TableRow hover tabIndex={-1} key={index}>
        <TableCell align="left">
          <Skeleton variant="rectangular" width={40} sx={{ my: 1.5 }} />
        </TableCell>
        <TableCell align="left">
          <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
        </TableCell>
        <TableCell align="left">
          <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
        </TableCell>
        <TableCell align="left">
          <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
        </TableCell>
        <TableCell align="left">
          <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
        </TableCell>
        <TableCell align="left">
          <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
        </TableCell>
        <TableCell align="left">
          <Skeleton variant="rectangular" width={40} sx={{ my: 1.5 }} />
        </TableCell>
        <TableCell align="left">
          <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
        </TableCell>
        <TableCell align="left">
          <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
        </TableCell>
        <TableCell align="left">
          <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
        </TableCell>
        <TableCell align="left">
          <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
        </TableCell>
        <TableCell align="left">
          <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
        </TableCell>
        <TableCell align="left">
          <Skeleton variant="rectangular" width={40} sx={{ my: 1.5 }} />
        </TableCell>
        <TableCell align="left">
          <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
        </TableCell>
        <TableCell align="left">
          <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
        </TableCell>
        <TableCell align="left">
          <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
        </TableCell>
        <TableCell align="left">
          <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
        </TableCell>
     
      </TableRow>
    ));
  }